/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_DateInputs */

const vi_expense_date = /** @type {(inputs: Expense_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày chi`)
};

/**

* @param {Expense_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_date = /** @type {((inputs?: Expense_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_date(inputs)
});